import React, { useCallback } from "react";
import "./PracticeByTechniqueTab.scss";

// image imports
import EasyIcon from "assets/icons/basicTechinc.png";
import MiddleIcon from "assets/icons/middleTechnic.png";
import HardIcon from "assets/icons/hardTechnic.png";
import Checkbox from "common/components/Checkbox";

interface Props {
  type?: "deffense" | "hand_play";
  search?: string;
  listChecked?: any;
  onChecked?: (val?: any, item?: any) => void;
  data?: any;
  onStartPractice?: () => void;
}

function PracticeByTechniqueTabDesktop({
  type = "hand_play",
  search,
  listChecked,
  onChecked,
  data,
  onStartPractice
}: Props) {
  const renderList = useCallback(
    (type: string) => {
      return (
        <>
          {data[type].map((val: any) => {
            if (search && val?.Data?.SubjectName.indexOf(search) === -1) {
              return null;
            }
            return (
              <Checkbox
                key={val.Data?.Id_ExSubject}
                label={val?.Data?.SubjectName}
                style={{ fontSize: 24 }}
                onClick={(item) => {
                  onChecked && onChecked(val, item);
                }}
              />
            );
          })}
        </>
      );
    },
    [data, onChecked, search]
  );

  return (
    <div className="PracticeByTechniqueTab-main" style={{ overflow: "hidden" }}>
      <div className="PracticeByTechniqueTab-boxes-otr">
        <div className="PracticeByTechniqueTab-box PracticeByTechniqueTab-box3">
          <img src={EasyIcon} />
          <h3 className="PracticeByTechniqueTab-heading">
            {type === "deffense" ? "טכניקות בסיסיות" : "טכניקות משחק כלליות"}
          </h3>
        </div>
        <div className="PracticeByTechniqueTab-box PracticeByTechniqueTab-box3">
          <img src={MiddleIcon} />
          <h3 className="PracticeByTechniqueTab-heading">
            {type === "deffense" ? "איתותים" : "טכניקות משחק בשליט"}
          </h3>
        </div>
        <div className="PracticeByTechniqueTab-box PracticeByTechniqueTab-box3">
          <img src={HardIcon} />
          <h3 className="PracticeByTechniqueTab-heading">
            {type === "deffense" ? "טכניקות מתקדמות" : "טכניקות משחק מתקדמות"}
          </h3>
        </div>
      </div>
      <div className="PracticeByTechniqueTab-boxes-otr">
        <div className="block-radio">{renderList("basic")}</div>
        <div className="block-radio">{renderList("middle")}</div>
        <div className="block-radio">{renderList("hard")}</div>
      </div>
      <div
        className={"PracticeByTechniqueTab-btn"}
        style={{ pointerEvents: listChecked.length > 0 ? undefined : "none" }}>
        <span
          className="start-btn"
          onClick={listChecked.length > 0 ? () => onStartPractice && onStartPractice() : undefined}>
          התחילו לתרגל
        </span>
      </div>
    </div>
  );
}

export default PracticeByTechniqueTabDesktop;
